import React, { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { Spinner } from '@hospitalrun/components'
import HospitalRun from './HospitalRun'

import store from './store'

import { AppInsightsContext } from '@microsoft/applicationinsights-react-js'
import { reactPlugin, ComponentWrapperWithAITracking } from 'analytics/AppInsights'

const App: React.FC = () => (
  <AppInsightsContext.Provider value={reactPlugin}>
    <div>
      <Provider store={store}>
        <Suspense fallback={<Spinner color="blue" loading size={[10, 25]} type="ScaleLoader" />}>
          <BrowserRouter>
            <HospitalRun />
          </BrowserRouter>
        </Suspense>
      </Provider>
    </div>
  </AppInsightsContext.Provider>
)

export default ComponentWrapperWithAITracking(App, 'app')
